import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const PasswordInput = ({
	label,
	id,
	placeholder,
	register,
	errors,
	onKeyDown,
	onChange = () => {},
	autoFocus = false,
	className,
	type = "text",
	toUpperCase = true,
}) => {
	const handleChange = (e) => {
		const { selectionStart, selectionEnd } = e.target;
		const value = toUpperCase ? e.target.value.toUpperCase() : e.target.value;
		e.target.value = value; // Atualiza o valor do input diretamente
		onChange({ ...e, target: { ...e.target, value } });

		// deixa o cursor no lugar correto após a mudança do valor
		setTimeout(() => {
			e.target.setSelectionRange(selectionStart, selectionEnd);
		}, 0);
	};

	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className={`input-box relative ${className}`}>
			<label htmlFor={id}>{label}</label>
			<input
				className={errors[id] ? "error" : ""}
				id={id}
				{...register(id, {
					onChange: (e) => {
						handleChange(e);
						onChange(e);
					},
				})}
				type={showPassword ? "text" : "password"}
				placeholder={placeholder}
				onKeyDown={onKeyDown}
				autoComplete="off"
				autoFocus={autoFocus}
			/>
			<FontAwesomeIcon
				icon={showPassword ? faEye : faEyeSlash}
				onClick={() => setShowPassword(!showPassword)}
				style={{
					position: "absolute",
					right: 10,
					top: 35,
					transform: "translateY(-50%)",
					cursor: "pointer",
				}}
			/>
			{errors[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default PasswordInput;
